import { formatCurrency } from "@/lib/format";

function Group({ title, items, total }) {
  return (
    <div className="border-b border-slate-100 last:border-b-0">
      <div className="px-4 sm:px-6 py-3 bg-slate-50/60">
        <span className="text-xs font-semibold uppercase tracking-widest text-slate-600">{title}</span>
      </div>
      {items.length === 0 ? (
        <div className="px-4 sm:px-6 py-3 text-sm text-slate-400">No items</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {items.map((it, idx) => (
            <li key={idx} className="px-4 sm:px-6 py-2.5 flex items-center justify-between gap-4">
              <span className="text-sm text-slate-700 truncate">{it.name}</span>
              <span className="text-sm font-medium text-slate-900 tabular-nums">{formatCurrency(it.amount)}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="px-4 sm:px-6 py-3 flex items-center justify-between border-t border-slate-200">
        <span className="text-sm font-semibold text-slate-800">Total {title}</span>
        <span className="text-sm font-bold text-slate-900 tabular-nums">{formatCurrency(total)}</span>
      </div>
    </div>
  );
}

export default function BalanceSheetTable({ data }) {
  if (!data) return null;
  const s = data.sections || {};
  const sum = data.summary || {};
  const liabPlusEquity = (sum.total_liabilities || 0) + (sum.total_equity || 0);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-testid="balance-sheet-table">
      <div className="px-4 sm:px-6 py-4 border-b border-slate-200">
        <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Balance Sheet</div>
        <div className="font-display text-xl font-semibold text-slate-900 mt-0.5">{data.company || "Statement"}</div>
        {data.period && <div className="text-xs text-slate-500 mt-0.5">{data.period}</div>}
      </div>

      <Group title="Assets" items={s.assets?.items || []} total={s.assets?.total || sum.total_assets || 0} />

      <div className="px-4 sm:px-6 py-3 flex items-center justify-between bg-[#1f64c2]/5 border-y border-slate-200">
        <span className="text-sm font-semibold text-[#1f64c2]">Total Assets</span>
        <span className="text-base font-bold text-[#1f64c2] tabular-nums">{formatCurrency(sum.total_assets || 0)}</span>
      </div>

      <Group title="Liabilities" items={s.liabilities?.items || []} total={s.liabilities?.total || sum.total_liabilities || 0} />
      <Group title="Equity" items={s.equity?.items || []} total={s.equity?.total || sum.total_equity || 0} />

      <div className="px-4 sm:px-6 py-4 flex items-center justify-between bg-slate-900 text-white">
        <span className="text-sm font-semibold">Total Liabilities + Equity</span>
        <span className="text-lg font-bold tabular-nums text-white">{formatCurrency(liabPlusEquity)}</span>
      </div>
    </div>
  );
}
